import { ClassType } from '@frontend/common';
import { DefaultModalProps } from '@frontend/modal';
import React from 'react';
import { FormattedMessage } from 'react-intl';

interface Props extends DefaultModalProps {
    severity?: ClassType;
    title?: React.ReactNode;
    message: React.ReactNode;
    onConfirm: () => void;
    cascadeWarning?: boolean;
}

const styles = {
    button: {
        primary: 'btn-brand-primary',
        secondary: 'btn-brand-secondary',
        success: 'btn-status-success',
        warning: 'btn-status-warning',
        danger: 'btn-status-danger',
        info: 'btn-status-info'
    }
};

export function ConfirmationModal(props: Props) {
    const buttonClass =
        props.severity && styles.button[String(props.severity) as keyof typeof styles.button]
            ? styles.button[String(props.severity) as keyof typeof styles.button]
            : styles.button['info'];
    return (
        <div className='bg-background-default'>
            <div className='flex flex-col p-5'>
                <h3 className={`text-${props.severity ? props.severity : 'info'} text-gradient text-2xl font-bold`}>
                    {props.title ? (
                        props.title
                    ) : (
                        <FormattedMessage
                            id='ConfirmationModal.title'
                            description='The title of the modal asking for confirmation'
                            defaultMessage='Are you sure?'
                        />
                    )}
                </h3>
                <div className='my-3'>{props.message}</div>
                {props.cascadeWarning && (
                    <span className='text-warning font-bold'>
                        <FormattedMessage
                            id='ConfirmationModal.cascade-warning'
                            description='A warning that deleting this item will delete other items'
                            defaultMessage='Be Careful! Other linked items might get unlinked or deleted.'
                        />
                    </span>
                )}
            </div>
            <div className='modal-footer flex flex-row items-center justify-between p-5'>
                <button
                    onClick={(e) => {
                        e.preventDefault();
                        props.onConfirm();
                    }}
                    id='confirmation-confirm-button'
                    className={`btn ${buttonClass}`}>
                    <FormattedMessage
                        id='ConfirmationModal.answer.yes'
                        description='The no answer yes the confirmation'
                        defaultMessage='Yes'
                    />
                </button>
                <button
                    id='confirmation-cancel-button'
                    onClick={props.handleClose}
                    className='btn btn-brand-secondary outline-brand-secondary outline'>
                    <FormattedMessage
                        id='ConfirmationModal.answer.no'
                        description='The no answer on the confirmation'
                        defaultMessage='No'
                    />
                </button>
            </div>
        </div>
    );
}
